import React, { memo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Modal } from '@material-ui/core'

import CircleCheck from 'components/CommonUI/svgIcons/CircleCheck'
import { useShallowEqualSelector } from 'custom-hooks'
import {
    getSuccessSendFormData,
    setSuccessSendFormData,
} from 'redux/reducers/profile'

const SuccessHelpSupportModal = () => {
    const dispatch = useDispatch()

    const { message, timeout, isShow } = useShallowEqualSelector(
        getSuccessSendFormData
    )

    useEffect(() => {
        let _t = null
        if (isShow) {
            _t = setTimeout(() => {
                dispatch(setSuccessSendFormData({ isShow: false }))
            }, timeout)
        }

        return () => {
            clearTimeout(_t)
        }
    }, [dispatch, isShow, timeout])

    return (
        <Modal open={isShow}>
            <div className="modal_dialog">
                <CircleCheck className="success_modal_icon" />
                <span className="success_modal_message">{message}</span>
            </div>
        </Modal>
    )
}

export default memo(SuccessHelpSupportModal)
